/**
 * A same-page `#id` link: scroll to the section smoothly (instantly under
 * reduced motion) and still update the address, so the back button behaves as
 * before. Returns false, leaving the browser's default, when the href is not
 * an anchor or the target is missing.
 *
 * Under a pinned header (one marked `data-pinned-header`) the section lands
 * just below it; elsewhere the section's own `scroll-margin` decides.
 */
export function scrollToAnchor(e: React.MouseEvent<HTMLElement>, href: string): boolean {
  if (!href.startsWith('#')) return false
  const target = document.getElementById(href.slice(1))
  if (!target) return false
  e.preventDefault()
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  const pinned = document.querySelector<HTMLElement>('[data-pinned-header]')
  if (pinned) {
    const top = target.getBoundingClientRect().top + window.scrollY - pinned.offsetHeight - 16
    window.scrollTo({ top, behavior })
  } else {
    target.scrollIntoView({ behavior, block: 'start' })
  }
  window.history.pushState(null, '', href)
  return true
}
